var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrientationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 29,
    viewBox: "0 0 34 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 29,
    rx: 3.91304,
    transform: "matrix(-1 0 0 1 34 0)",
    fill: "#FF947A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3515 7.875C22.8368 9 24.569 11.4 24.8703 14.25H26C25.5481 9.6 21.7071 6 16.9623 6H16.4351L19.2971 8.85L20.3515 7.875ZM15.6067 7.275C15.1548 6.825 14.477 6.825 14.0251 7.275L9.20502 12.075C8.75314 12.525 8.75314 13.2 9.20502 13.65L18.2427 22.65C18.6946 23.1 19.3724 23.1 19.8243 22.65L24.6444 17.85C25.0962 17.4 25.0962 16.725 24.6444 16.275L15.6067 7.275ZM19.0711 21.9L10.0335 12.9L14.8536 8.1L23.8912 17.1L19.0711 21.9ZM13.5732 22.125C11.0879 21 9.35565 18.6 9.05439 15.75H8C8.37657 20.4 12.2176 24 16.9623 24H17.4895L14.6276 21.15L13.5732 22.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrientationIcon);
export default __webpack_public_path__ + "static/media/orientationIcon.375c124df23f71db4c4e4bfcd562b2b7.svg";
export { ForwardRef as ReactComponent };